import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Multistep } from '@/components/multistep/Multistep';
import { Step } from '@/components/multistep/Questionnaire';
import { Card } from '@/components/sections/Card';
import { CSVProvider } from '@/services/csv/CSVService';

import { FunctionComponent, Suspense } from 'react';
import { IssuesStep, ReviewStep, UploadStep } from './BulkCreateCustomerUtils';

const BulkCreateCustomerModal: FunctionComponent<ModalProps<{ mspId: string }>> = props => {
  return (
    <Modal className="md:max-w-4xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Bulk upload customers</h1>
        </Modal.Controls>
        <CSVProvider>
          <Multistep>
            <Suspense fallback={<Loading />}>
              <div className="my-6">
                <UploadStep />
                <Step
                  id="issues"
                  title="Issues"
                  description="There were some issues with parsing or validating the spreadsheet. Please resolve them and reupload the spreadsheet."
                  controls="manual"
                >
                  <IssuesStep />
                </Step>
                <Step
                  id="review"
                  title="Review"
                  description="Please review the customers below and press continue to upload them to the system."
                  controls="manual"
                >
                  <ReviewStep
                    mspId={props.props?.mspId}
                    nextLabel="Finish"
                    onFinish={() => {
                      props.close();
                      return true;
                    }}
                  />
                </Step>
              </div>
            </Suspense>
          </Multistep>
        </CSVProvider>
      </Card>
    </Modal>
  );
};

export default BulkCreateCustomerModal;
